import { Component, inject } from '@angular/core';
import { FirebreakService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FirebreakCreateDto,
  FirebreakDto,
  FirebreakExcelDownloadDto,
  FirebreakUpdateDto,
} from '../proxy/planning/dtos/firebreak';
import { FIREBREAK_CONFIG, FIREBREAK_FIELDS } from './firebreak.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-firebreak',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FirebreakService, ConfirmationService],
  templateUrl: './firebreak.html',
  styleUrl: './firebreak.scss',
})
export class Firebreak extends BaseHierarchicalCrudComponent<
  FirebreakDto,
  FirebreakCreateDto,
  FirebreakUpdateDto,
  FirebreakExcelDownloadDto
> {
  service = inject(FirebreakService);
  config = FIREBREAK_CONFIG;
  fields = FIREBREAK_FIELDS;

  protected prepareUpdateDto(data: any, selected: FirebreakDto): FirebreakUpdateDto {
    return {
      isActive: data.isActive,
      hectares: data.hectares,
      locationId: data.locationId,
      firebreakTypeId: data.firebreakTypeId,
      gisFirebreakId: data.gisFirebreakId,
      firebreakBlockId: data.firebreakBlockId,
      propertyId: data.propertyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Firebreak';
  }
}
